import React, { useEffect } from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateCollateralStatusReduxParams } from '~types/feat/approval';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateCollateralStatusModal.module.scss';

const ConfirmUpdateCollateralStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateCollateralStatusModalIsOpen);
    const tempUpdateCollateralState = useAppSelector(state => state.approval.tempUpdateCollateralState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateCollateralStatus);
    const error = useAppSelector(state => state.approval.errors.updateCollateralStatus);

    const getStatus = () => {
        switch (tempUpdateCollateralState.status) {
            case (TransactionStatusEnum.Approved): return 'Approve';
            case (TransactionStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateCollateralStatusModalIsOpen(open));
    const updateCollateralStatus = (data: TUpdateCollateralStatusReduxParams) => dispatch(combinedActions.approvalUpdateCollateralStatusAttempt(data));

    const handleSubmitClick = () => {
        updateCollateralStatus(tempUpdateCollateralState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateCollateralStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Collateral?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateCollateralStatusModal;
